export enum IxNotesModule {
    Meldung,
    Auftrag,
    TO
}
